<script>
	import { quintOut } from "svelte/easing";
	import { crossfade } from "svelte/transition";
	import Card from "./card.svelte";

	export let cards = [];
	export let onCardDrop = () => {};
	export let padding = 60;
	export let cardAnimationProps = null;
	export let animate = true;

	$: isLifted = null;
	$: cardsElement = null;
	let cardWidth = 70;
	if (window.innerWidth > 768) {
		cardWidth = 85;
	}
	if (window.innerWidth > 1020) {
		cardWidth = 95;
	}

	let cardsStyle = `
		padding-left: ${padding}px;
		padding-right: ${padding}px;
		max-width: calc(100% - ${2 * padding}px);
	`;

	$: getCardStyle = (card, index) => {
		let cardStyle = `z-index: ${isLifted === card ? 99 : index};`;
		if (cardsElement && index !== cards.length - 1) {
			const computedStyle = window.getComputedStyle(cardsElement);
			const width = Number(computedStyle.width.replace("px", ""));
			const length = Math.max(cards.length, 3);
			cardStyle += `
				margin-right: ${(width - length * cardWidth) / (length - 1)}px;
			`;
		}

		return cardStyle;
	}

	$: [send, receive] = crossfade({
		duration: (d) => {
			return Math.sqrt(d * 200);
		},

		fallback(node, params) {
			const style = getComputedStyle(node);
			const { top, left } = node.getBoundingClientRect();
			const transform = style.transform === 'none' ? '' : style.transform;
			const shouldAnimate = cards && animate && !!cardAnimationProps;
			let translate = t => "";

			if (shouldAnimate && cardAnimationProps.style) {
				translate = (t) => {
					const translateX = (cardAnimationProps.style.left - left - cardWidth / 2) * (1 - t);
					const translateY = (cardAnimationProps.style.top - top - 336 / 240 * cardWidth / 2)  * (1 - t);

					return `translate(${translateX}px, ${translateY}px)`;
				};
			}

			return {
				duration: shouldAnimate ? 1000 : 0,
				easing: quintOut,
				css: (t) => {
					return shouldAnimate ? `
						transform: ${transform} ${translate(t)} scale(${Math.min(1, 1.5 * t)});
						opacity: ${t}
					` : "opacity: 0";
				}
			};
		}
	});

	const onCardLift = (card) => {
		isLifted = card;
	}

	const onCardDropHandler = (card, position) => {
		isLifted = null;
		onCardDrop(card, position);
	}
</script>

<div class="cards" style={cardsStyle} bind:this={cardsElement}>
	{#each cards as card, index (card)}
		<div style={getCardStyle(card, index)} in:receive out:send>
			<Card
				{card}
				onCardDrop={onCardDropHandler}
				{onCardLift}
				width={cardWidth}
			/>
		</div>
	{/each}
</div>

<style>
	.cards {
		display: flex;
		flex-direction: row;
		flex-grow: 1;
	}
</style>